import {
  Directive,
  ElementRef,
  ChangeDetectorRef,
  inject,
  input,
  signal,
  output,
  OnInit,
  OnDestroy,
  InputSignal,
  OutputEmitterRef,
  WritableSignal
} from '@angular/core';
import { SPLIT_BUTTONS_REGISTRATION, SplitButtonLike, SplitButtonsRegistration } from './split-button.contract';

@Directive()
export class BaseSplitButtonComponent<T> implements OnInit, OnDestroy, SplitButtonLike<T> {
  readonly value: InputSignal<T | undefined> = input<T>();
  readonly selectChange: OutputEmitterRef<boolean> = output<boolean>();

  readonly active: WritableSignal<boolean> = signal(false);
  readonly disabled: WritableSignal<boolean> = signal(false);
  readonly parentId: WritableSignal<string | undefined> = signal<string | undefined>(undefined);
  private readonly id: WritableSignal<number | undefined> = signal<number | undefined>(undefined);

  private readonly elementRef = inject(ElementRef);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly parentSplitButtons: SplitButtonsRegistration<T> | null = inject(SPLIT_BUTTONS_REGISTRATION, { optional: true }) as SplitButtonsRegistration<T> | null;

  ngOnInit(): void {
    this.parentSplitButtons?.registerButton(this);
  }

  ngOnDestroy(): void {
    this.parentSplitButtons?.unregisterButton(this);
  }

  get el(): ElementRef {
    return this.elementRef;
  }

  setParentId(parentId: string): void {
    this.parentId.set(parentId);
    this.changeDetectorRef.detectChanges();
  }

  setButtonId(id: number): void {
    this.id.set(id);
  }

  getButtonId(): number | undefined {
    return this.id();
  }

  setActive(active: boolean): void {
    if (this.active() !== active) {
      this.active.set(active);
      this.changeDetectorRef.markForCheck();
    }
  }

  setDisabled(disabled: boolean): void {
    if (this.disabled() !== disabled) {
      this.disabled.set(disabled);
      this.changeDetectorRef.markForCheck();
    }
  }

  isActive(): boolean {
    return this.active();
  }

  onSelect(): void {
    if (this.disabled()) {
      return;
    }
    this.active.set(true);
    this.selectChange.emit(this.active());
  }

  getValue(): T | undefined {
    return this.value();
  }
}
